import { render, staticRenderFns } from "./PostPagination.vue?vue&type=template&id=5de7c7e8&"
import script from "./PostPagination.vue?vue&type=script&lang=js&"
export * from "./PostPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports